<template>
  <header>
    <div class="center grid">
      <vs-row w-full>
        <vs-col :lg="6" :sm="12">
          <div class="leftMenu">
            <h2>SelfCare</h2>
          </div>
        </vs-col>
        <vs-col :lg="6" :sm="12">
          <div class="rightMenu">
            <div>
              <h3 class="phoneicon">
                <span class="material-symbols-outlined"> Phone </span>
                1800-102-0340
              </h3>
            </div>
            <div>
              <button class="notificationBtn">
                <span class="material-symbols-outlined"> Notifications </span>
              </button>
            </div>

            <div>
              <div class="dropdown">
                <button class="dropbtn">
                  <img
                    class="profileImg"
                    src="@/assets/images/profile_pic.svg"
                  />
                  <img src="@/assets/icons/expandMoreIcon.svg" />
                </button>

                <div class="dropdown-content">
                  <div class="profile_detail">
                    <div>
                      <img
                        class="profileImg"
                        src="@/assets/images/profile_pic.svg"
                      />
                    </div>
                    <div class="">
                      <h5>
                        {{
                          userInfo.clientData && userInfo.clientData.displayName
                        }}
                      </h5>
                      <span>
                        {{
                          userInfo.clientData && userInfo.clientData.email
                        }}</span
                      >
                    </div>
                  </div>
                  <a href="/profileSetting"
                    ><img src="@/assets/icons/profile_settings_icon.svg" />
                    Profile Settings</a
                  >
                  <a href="help"
                    ><img src="@/assets/icons/help_center_icon.svg" /> Help
                    Center</a
                  >
                  <!-- <a href="#"
                    ><img src="@/assets/icons/my_wallet_icon.svg" /> My
                    wallet</a
                  > -->
                  <a href="createManageService"
                    ><img src="@/assets/icons/upgrade_plan_icon.svg" /> Upgrade
                    Plan</a
                  >
                  <hr class="lineMenu" />
                  <a href="login"
                    ><img src="@/assets/icons/signout_icon.svg" /> Sign Out</a
                  >
                </div>
              </div>
            </div>
          </div>
        </vs-col>
      </vs-row>
    </div>
  </header>
</template>
<script>
export default {
  computed: {
    userInfo() {
      return this.$store.getters["auth/getUser"];
    }
  }
};
</script>
<style scoped>
header {
  width: 100%;
  background-color: #ffffff;
  border-bottom: 1px solid #e4ecff;
}

nav {
  height: 100%;
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

li {
  margin: 0 1rem;
}

a {
  text-decoration: none;
  color: white;
  font-weight: bold;
  font-size: 1.25rem;
  border: 1px solid transparent;
  padding: 0.5rem;
  display: inline-block;
}

a:hover,
a:active,
a.router-link-active {
  color: #ecb5f3;
  border-color: #ecb5f3;
}
.leftMenu {
  padding: 10px 30px;
}
.leftMenu h2 {
  margin-bottom: 5px;
  font-size: 34px;
  font-weight: 700;
  margin-top: 5px;
}
.leftMenu p {
  margin: 0;
  font-size: 21px;
  font-weight: 400;
}
.rightMenu {
  padding: 10px 30px;
  display: flex;
  justify-content: right;
  align-items: center;
}
.rightMenu > div {
  margin-right: 15px;
}
.rightMenu div h3 {
  margin-bottom: 0;
  font-size: 20px;
  font-weight: 700;
  margin-top: 0;
  color: #2b3674;
}
.phoneicon {
  display: flex;
  align-items: center;
}
.phoneicon span {
  margin-right: 15px;
}

/* ----Notification Start---- */
.notificationBtn {
  background: transparent;
  border: 1px solid #bfbfbf;
  height: 40px;
  width: 40px;
  border-radius: 50px;
  position: relative;
}
.notificationBtn::after {
  position: absolute;
  height: 10px;
  width: 10px;
  background: #15956f;
  content: "";
  right: 0;
  top: 0;
  z-index: 77;
  border-radius: 50px;
}
.notificationBtn span {
  color: #bfbfbf;
  font-weight: 400;
}
/* ----Notification Start---- */
/* ----DropDown Menu Start---- */
.dropbtn {
  background-color: transparent;
  color: white;
  font-size: 16px;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
}
.profileImg {
  margin-right: 15px;
}
.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #fff;
  min-width: 250px;
  box-shadow: 0px 30px 40px 0px rgba(0, 0, 0, 0.15);
  z-index: 9;
  right: 0;
  top: 120%;
}

.dropdown-content a {
  padding: 15px 14px;
  text-decoration: none;
  display: flex;
  color: #2b3674;
  font-size: 14px;
  font-weight: 500;
}
.dropdown-content a img {
  margin-right: 15px;
}

.dropdown-content a:hover {
  background-color: #f7f9fc;
  border: 1px solid #e4ecff;
}
.dropdown-content:before {
  position: absolute;
  top: -20px;
  left: 0;
  width: 100%;
  height: 20px;
  content: "";
  display: block;
  z-index: 1;
}
.dropdown-content:after {
  position: absolute;
  top: -7px;
  right: 30px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid #f7f9fc;
  content: "";
  display: block;
  z-index: 2;
  transition: all 200ms linear;
}

.dropdown:hover .dropdown-content {
  display: block;
}
hr.lineMenu {
  margin: 0;
  border: 0.7px solid #f5f5f5;
}
.profile_detail {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f7f9fc;
  padding: 15px 0;
}
.profile_detail h5 {
  margin: 0;
  color: #2b3674;
  font-size: 14px;
}
.profile_detail span {
  color: #a3aed0;
  font-size: 13px;
}

/* ----DropDown Menu End---- */
</style>
